import { Component, computed, inject, Signal } from '@angular/core';
import { SelectComponent } from '@kinomap-dev/ng-ui-lib/forms';
import { SelectField } from '../select-field/select-field';
import { TranslateModule } from '@ngx-translate/core';
import { LanguageService, LanguageType } from '../../services/language.service';
import { UpperFirstLetterPipe } from '../../pipes/upper-first-letter-pipe';

export type LanguageSelectOption = LanguageType & { navigatorLanguage: boolean };

@Component({
  selector: 'app-language-select',
  imports: [SelectComponent, SelectField, TranslateModule, UpperFirstLetterPipe],
  templateUrl: './language-select.html',
  styleUrl: './language-select.scss',
})
export class LanguageSelect {
  protected readonly languageService: LanguageService = inject(LanguageService);
  protected readonly languageOptions: LanguageSelectOption[] =
    this.languageService.availableLanguages.map((lang: LanguageType) => ({
      ...lang,
      navigatorLanguage: this.languageService.navigatorLanguage === lang.code.split('-')[0],
    }));

  protected readonly currentFlagUrl: Signal<string> = computed(
    () => `assets/storybook-assets/flags/${this.languageService.currentLanguage().countryCode}.svg`,
  );
}
